import DescriptionPaneNumberEditor from './DescriptionPaneNumberEditor';

export default DescriptionPaneNumberEditor;
export { DescriptionPaneNumberEditor };
